var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-tabs',_vm._g(_vm._b({model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'van-tabs',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.option),function(tab,index){return _c('van-tab',{key:index,attrs:{"title":tab}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }